import { ApplicationConfig, importProvidersFrom, provideAppInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { appRoutes } from './app.routes';
import { provideTranslateService } from '@ngx-translate/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { AccountLogic, AccountStateService, EnvironmentService } from '@mwe/services';
import { APPLICATION_NAME, DEFAULT_POPUP_COMPONENT_TOKEN, ENVIRONMENT_SERVICE_TOKEN, LOCATION_TOKEN } from '@mwe/constants';
import { OAuthModule, OAuthService, UrlHelperService } from 'angular-oauth2-oidc';
import { provideWebstorage, withLocalStorage, withSessionStorage } from '@mwe/utils';
import { IkpEnvironmentService } from './service/environment/ikp-environment.service';
import { provideKeycloak } from 'keycloak-angular';
import keycloakConfig from './config/keycloak.config';
import { HeadlineService, ModalDialogComponent } from '@mwe/ui/components';
import { authInterceptor } from './interceptor/auth.interceptor';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { registerLocaleData } from '@angular/common';
import localeDeDE from '@angular/common/locales/de';
import { dropdownTypeMapping } from './utils/ikp-dropdown-transformers';
import { DROPDOWN_TRANSFORMERS } from '@shared-ikp/app.constants';
import { errorResponseInterceptor } from './interceptor/error-response.interceptor';
import { providePiwikTracking } from './utils/ikp-piwik.provider';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(appRoutes, withInMemoryScrolling({ scrollPositionRestoration: 'top' })),
    provideHttpClient(withInterceptors([authInterceptor, errorResponseInterceptor])),
    importProvidersFrom(OAuthModule.forRoot()),
    provideKeycloak({
      config: keycloakConfig,
      initOptions: {
        onLoad: 'check-sso',
        checkLoginIframe: false,
        silentCheckSsoRedirectUri: `${window.location.origin}/assets/silent-check-sso.html`,
      },
    }),
    provideTranslateService({
      lang: 'de',
      loader: provideTranslateHttpLoader({ prefix: 'assets/i18n/', suffix: '.json', enforceLoading: true }),
    }),
    provideAppInitializer(() => {
      registerLocaleData(localeDeDE, 'de-DE');
    }),
    provideWebstorage(withLocalStorage({ delimiter: '_', prefix: 'ikp' }), withSessionStorage({ delimiter: '_', prefix: 'ikp' })),
    providePiwikTracking(),
    provideZoneChangeDetection(),
    { provide: APPLICATION_NAME, useValue: 'MWE' },
    { provide: LOCATION_TOKEN, useValue: 'local' },
    { provide: EnvironmentService, useClass: IkpEnvironmentService },
    { provide: ENVIRONMENT_SERVICE_TOKEN, useClass: IkpEnvironmentService },
    { provide: AccountStateService, useClass: AccountStateService },
    { provide: AccountLogic, useClass: AccountLogic },
    { provide: OAuthService, useClass: OAuthService },
    { provide: UrlHelperService, useClass: UrlHelperService },
    { provide: HeadlineService, useClass: HeadlineService },
    { provide: DEFAULT_POPUP_COMPONENT_TOKEN, useValue: ModalDialogComponent },
    { provide: DROPDOWN_TRANSFORMERS, useValue: dropdownTypeMapping },
  ],
};
